import React from 'react';
import { Button } from './Button';
export function PersuasiveCTA() {
  return <section className="py-6 px-3 bg-brand-dark flex justify-center border-b border-white/10" data-id="element-182">
      <div className="w-full max-w-lg mx-auto text-center" data-id="element-183">
        <Button className="text-sm md:text-xl py-4 md:py-5 shadow-xl" data-id="element-184">
          🚀 SÍ, QUIERO DEJAR DE IMPROVISAR
        </Button>
      </div>
    </section>;
}